import React, { useState } from "react";
import { Chip, IconButton, Popover, Stack, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import { ReportCashflowAllocationTarget, ReportCashflowAum } from "store/types";
import { PopoverContent } from "./PopoverContent";
export interface IAllocationTarget {
  id: number | string;
  share: number;
  asset_class_id: number;
  years: number;
  is_deleted: boolean;
}

interface Props {
  aumData: ReportCashflowAum | null;
  allocationTargetData: ReportCashflowAllocationTarget[];
  updateAllocationTarget: (data: { aum_id: number; targets: IAllocationTarget[] }) => void;
  loadingStatus: {
    aumLoading: boolean;
    allocationTargetLoading: boolean;
    graphLoading: boolean;
  };
}

export const AllocationTarget: React.FC<Props> = ({
  allocationTargetData,
  updateAllocationTarget,
  aumData,
  loadingStatus
}) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setMenuAnchorEl(null);
  };

  return (
    <>
      <Stack
        sx={{
          flexDirection: "row",
          gap: "10px",
          width: "100%",
          overflow: "hidden",
          alignItems: "flex-start"
        }}
      >
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: "14px",
            color: "#071F35",
            whiteSpace: "nowrap",
            flexShrink: 0,
            flexBasis: "auto"
          }}
        >
          Allocation Target:
        </Typography>
        <Stack
          direction="row"
          gap="5px"
          sx={{
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: 0,
            minWidth: 0,
            overflow: "hidden",
            marginRight: "25px"
          }}
        >
          <IconButton
            disabled={Object.values(loadingStatus).some((status) => status === true)}
            sx={{
              backgroundColor: "#f8f8f8f5",
              flexShrink: 0,
              height: "24px",
              width: "24px"
            }}
            onClick={handleOpen}
          >
            <AddIcon />
          </IconButton>
          {Boolean(allocationTargetData.length) && (
            <Stack
              sx={{
                overflow: "auto",
                flexGrow: 1,
                flexShrink: 1,
                flexBasis: 0,
                minWidth: 0,
                paddingBottom: "15px"
              }}
              direction="row"
              gap="10px"
            >
              {allocationTargetData.map((target, index) => (
                <Chip
                  key={index}
                  label={
                    <Stack direction="row" gap="5px">
                      <Typography sx={{ fontSize: "12px" }}>{target.asset_class_name}</Typography>
                      <Typography component="span" sx={{ fontWeight: "bold", fontSize: "12px" }}>
                        {`${target.share}%`}
                      </Typography>
                    </Stack>
                  }
                  sx={{ flexShrink: 0, height: "24px" }}
                />
              ))}
            </Stack>
          )}
        </Stack>
      </Stack>
      <Popover
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={onClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
      >
        <PopoverContent
          allocationTargetData={allocationTargetData}
          onClose={onClose}
          updateAllocationTarget={updateAllocationTarget}
          aumData={aumData}
        />
      </Popover>
    </>
  );
};
